import * as React from "react";
const SvgFiRrMicrophoneAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-microphone-alt_svg__a)">
      <path
        fill="#062147"
        d="M18.757 16a5.21 5.21 0 0 0-3.707 1.535A15.14 15.14 0 0 1 4.272 22h-1.15a1.121 1.121 0 0 1-.794-1.914l.693-.693a7.77 7.77 0 0 0 5.1-2.272l4.326-4.321c.422.113.856.18 1.292.2H14a6.02 6.02 0 0 0 4.246-1.758l1-1a6.01 6.01 0 0 0 1.139-6.9A5.95 5.95 0 0 0 18.848 1.4a6.18 6.18 0 0 0-8.274.544l-.633.634A6.33 6.33 0 0 0 8.247 8.51L3.88 12.879a7.76 7.76 0 0 0-2.272 5.1l-.693.693A3.121 3.121 0 0 0 3.122 24h1.15a17.13 17.13 0 0 0 12.192-5.05A3.244 3.244 0 0 1 22 21.242V23a1 1 0 0 0 2 0v-1.758A5.25 5.25 0 0 0 18.757 16m-7.4-12.012.633-.634a4.41 4.41 0 0 1 3.1-1.3 3.8 3.8 0 0 1 2.471.877 3.97 3.97 0 0 1 1.44 2.895 4.01 4.01 0 0 1-1.168 3l-1 1a4 4 0 0 1-5.9-.266 4.17 4.17 0 0 1 .422-5.572zM5.293 14.293l3.836-3.837c.091.13.164.27.267.393.332.392.712.74 1.131 1.038l-3.82 3.82a5.8 5.8 0 0 1-3.018 1.6 5.8 5.8 0 0 1 1.604-3.014"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-microphone-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMicrophoneAlt;
